@if (documentName) {
<div fxLayout="row wrap">
  <mat-card appearance="outlined" fxFlex="50">
    <mat-card-header>
      <mat-card-title>Case Information</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-elevation-z8 no-bottom-pad" style="height: 100%">
      <table aria-label="Table with case information" role="presentation" class="info-table">
        <colgroup>
          <col style="width: 30%;">
          <col style="width: 70%;">
        </colgroup>
        <tbody>
          <tr>
            <td><span><strong>Protester</strong></span></td>
            <td><span>{{ protestInfo.company_Name }}</span></td>
          </tr>
          <tr>
            <td><span><strong>B-Number</strong></span></td>
            <td>
              <span [ngClass]="{ 'pending-entry color_warn': !protestInfo.b_No }" [matTooltip]="protestInfo.a_No">
                {{ protestInfo.b_No || "pending" }}
              </span>
            </td>
          </tr>
          <tr>
            <td><span><strong>Agency</strong></span></td>
            <td><span>{{ protestInfo.agency_Name }}</span></td>
          </tr>
          <tr>
            <td><span><strong>Solicitation Number</strong></span></td>
            <td><span>{{ protestInfo.solicitation_No }}</span></td>
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" fxFlex="50">
    <mat-card-header>
      <mat-card-title>Document Information</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-elevation-z8 no-bottom-pad" style="height: 100%">
      <table aria-label="Table with document information" role="presentation" class="info-table">
        <colgroup>
          <col style="width: 30%;">
          <col style="width: 70%;">
        </colgroup>
        <tbody>
          <tr>
            <td><strong>Docket#</strong></td>
            <td>
              <span>
                {{ docketInfo.index }}
              </span>
            </td>
          </tr>
          <tr>
            <td><span><strong>Document Type</strong></span></td>
            <td><span>{{documentName}}</span></td>
          </tr>
          <tr>
            <td><span><strong>Filer</strong></span></td>
            <td>
              <span *ngIf="fileInfo?.submitter_Role != 'GAO' && fileInfo?.submitter_Role != 'AGENCY'">
                {{ fileInfo?.submitter_Role }} ({{ fileInfo?.company_Name }})
              </span>
              <span *ngIf="fileInfo?.submitter_Role == 'GAO'">GAO</span>
              <span *ngIf="fileInfo?.submitter_Role == 'AGENCY'">
                {{ fileInfo?.submitter_Role }} ({{ fileInfo?.company_Name }})
              </span>
            </td>
          </tr>
          <tr>
            <td><span><strong>Submission Date</strong></span></td>
            <td>
              <span>
                {{ fileInfo?.transient_Date }} {{ fileInfo?.transient_Time }}
              </span>
            </td>
          </tr>
          <tr>
            <td><span><strong>Comments</strong></span></td>
            <td>
              <span>
                {{ fileInfo?.transient_Comments }}
              </span>
            </td>
          </tr>
          <tr>
            <td><span><strong>GAO Notes</strong></span></td>
            <td>
              <span>
                {{ fileInfo?.transient_Note }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>

@if (isUploadDoc) {
  <mat-card>
    <mat-card-content>
      <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
        <mat-label>Upload Document (Only PDF and Excel files can be attached)</mat-label>
        <input matInput style="display: none" required />

        <app-file-upload #fileUpload
                         [fileUploadInProgress]="fileUploadInProgress"
                         [wrongFileTypeMessage]="requiredFileMessage" [requiredFileType]="requiredFileType" [showAssociatedDocuments]="false"
                         (attachAssociatedDocOutput)="attachAssociatedDocOutput = $event"
                         (primaryEPDSFileListOutput)="onEPDSFileListChange($event)">
        </app-file-upload>
      </mat-form-field>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button (click)="submitFileUpload()" color="primary"  [disabled]="loadingAfterSubmit" mat-raised-button type="submit" class="spinner-black">
          <div *appSpinner="loadingAfterSubmit"></div>
          Submit
        </button>
      </div>
    </mat-card-content>
  </mat-card>
}

<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title fxLayout="row" fxLayoutAlign="space-between">
      {{this.documentName}} <div *appSpinner="loading; color: 'primary'"></div>
      @if (stateService.userRole === UserRole.GAO_Admin || stateService.userRole === UserRole.GAO_Supervisor || stateService.userRole === UserRole.GAO_Attorney) {
        @if(isProtestDocumentInfoEditable) {
          <button mat-icon-button (click)="onCancel()" matTooltip="Cancel edit"><mat-icon>cancel</mat-icon></button>
        } @else {
          <button mat-icon-button (click)="onEdit()" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
        }
      }
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mat-elevation-z8" fxLayout="column">
    <table aria-label="Table with case information" role="presentation" style="width: 100%;">
      <colgroup>
        <col style="width: 72px;">
        <col>
        <col style="width: 148px;">
      </colgroup>
      <tbody>
        <tr>
          <td colspan="3"><span><strong>Primary Document</strong></span></td>
        </tr>
        @for (primaryDocument of primaryDocuments; track primaryDocument) {
          @if (primaryDocument.fileName) {
            <tr>
              <td></td>
              <td class="doc-name">
                <a href="{{util.getBaseURL()}}/epds/downloaddashboardfile?fileId={{primaryDocument.file_Id}}" target="_blank">{{primaryDocument.fileName}}</a>
              </td>
              <td>
                @if (stateService.userRole === UserRole.GAO_Admin) {
                  @if(isProtestDocumentInfoEditable){
                    @if(associatedDocuments.length > 0){
                      <button mat-icon-button matTooltip="Replace from existing documents"
                              (click)="onReplaceFromExisting()"><mat-icon>source_notes</mat-icon></button>
                    }
                    <button mat-icon-button matTooltip="Replace primary document"
                            (click)="onDocumentReplace(primaryDocument, 'P')"><mat-icon>folder_match</mat-icon></button>
                    <button mat-icon-button matTooltip="Delete primary document"
                            (click)="onDocumentDelete(primaryDocument)"><mat-icon>delete</mat-icon></button>
                  }
                }
              </td>
            </tr>
          }
        }
        <tr>
          <td colspan="3"><span><strong>Associated Documents</strong></span></td>
        </tr>
        @for (associatedDoc of associatedDocuments; track associatedDoc) {
          <tr>
            <td></td>
            <td class="doc-name">
              <a href="{{util.getBaseURL()}}/epds/downloaddashboardfile?fileId={{associatedDoc.file_Id}}" target="_blank">{{associatedDoc.fileName}}</a>
            </td>
            <td>
              @if (stateService.userRole === UserRole.GAO_Admin) {
                @if(isProtestDocumentInfoEditable){
                  <button mat-icon-button matTooltip="Replace associated document" (click)="onDocumentReplace(associatedDoc, 'A')">
                    <mat-icon>folder_match</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Delete associated document" (click)="onDocumentDelete(associatedDoc)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              }
            </td>
          </tr>
        }

        @if(showApproveQstn) {
          <tr>
            <td colspan="3"><span><strong>{{approveQstnText}}</strong></span></td>
          </tr>
          <tr>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <button mat-raised-button color="primary" (click)="onApprovalYes()">Yes</button>
              <button mat-raised-button color="warn" (click)="onApprovalNo()">No</button>
            </div>
          </tr>
        } @else {
          <tr>
            <td><span><strong>Protected</strong></span></td>
            <td>
              @if(!isProtectedEditable){
              <span>{{docketFileResponse.PO}}</span>
              }
              @if (isProtestDocumentInfoEditable && isProtectedEditable) {
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Protected</mat-label>
                <input matInput style="display:none">
                <mat-radio-group [(ngModel)]="protectedPO">
                  <mat-radio-button *ngFor="let protectedValue of ['Y', 'N']" [value]="protectedValue">
                    {{ protectedValue }}
                  </mat-radio-button>
                </mat-radio-group>
              </mat-form-field>
              }
            </td>
            <td>
              @if (stateService.userRole === UserRole.GAO_Admin || stateService.userRole === UserRole.GAO_Supervisor || stateService.userRole === UserRole.GAO_Attorney) {
                @if (isProtestDocumentInfoEditable) {
                  <app-edit-controls #poCtrl tooltipName="Protected" [editDisabled]="isProtectedEditable"
                    [originalValue]="docketFileResponse.PO" [(value)]="protectedPO" (onEdit)="onProtectedEdit()"
                    (onSave)="onProtectedSave()" (onCancel)="onProtectedCancel()">
                  </app-edit-controls>
                }
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </mat-card-content>
</mat-card>

@if(showSubmitNewDoc){
  <app-denial-of-document
    [fileInfo]="fileInfo" [denialDocInfoList]="denialDocInfoList"
    (onSubmitDenialDoc)="onSubmitDenialDoc()">
  </app-denial-of-document>
}
}
